import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import styles from '../SignUp_Login/signUp.styles';
import PanelWithImage from '../SignUp_Login/PanelWithImage';

import Copyright from '../shared-components/Copyright';
import logo from '../images/logo.png';
import { Backdrop } from '@mui/material';
import { Box } from '@mui/material';
import { Modal } from '@mui/material';
import { Fade } from '@mui/material';
import { useTranslation } from 'react-i18next';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
const useStyles = makeStyles()(styles);

function DeleteAccount() {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const [state, setState] = useState({
    email: '',
    errorMessage: '',
    successMessage: '',
    openDialog: false,
  });
  const [open, setOpen] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  function sendEmail() {
    if (!state.email) {
      return setState((prevState) => {
        return { ...prevState, errorMessage: 'Email is required' };
      });
    }
    setLoader(true);
    return fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/users/delete-request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: state.email,
      }),
    })
      .then((res) => {
        if (res.status === 404) {
          setState((prevState) => {
            return { ...prevState, errorMessage: 'User not found' };
          });
        } else {
          handleOpen();
          setState((prevState) => {
            return {
              ...prevState,
              successMessage: 'Email send',
              errorMessage: '',
            };
          });
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }

  return (
    <Grid container direction="row" justify="space-between" alignItems="center">
      <PanelWithImage />
      <Grid item className={classes.rightPanelContainer} xs={12} md={6}>
        <div className={classes.rightPanel}>
          <div className={classes.header}>
            <div>
              <img className={classes.logo} src={logo} alt="CAN logo" />
            </div>
            <Typography component="h1" variant="h5">
              Delete Account Request
            </Typography>
            <Typography className={classes.successMessage} component="h1" variant="subtitle1">
              {state.successMessage}
            </Typography>
          </div>
          <form
            className={classes.form}
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label={t('email')}
                  name="email"
                  autoComplete="email"
                  InputProps={{
                    className: classes.input,
                  }}
                  value={state.email}
                  onChange={(event) => {
                    const email = event.target.value;
                    return setState((prevState) => {
                      return { ...prevState, email };
                    });
                  }}
                />
              </Grid>
              <Grid item className={classes.errorMessageContainer}>
                <Typography className={classes.errorMessage} component="h1" variant="subtitle1">
                  {state.errorMessage}
                </Typography>
              </Grid>
              <Grid item className={`${classes.infoMessage} ${classes.grayText}`}>
                Enter your email address connected to your account. A confirmation email will be send to your email
                address.
              </Grid>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => sendEmail()}
                disabled={loader}
              >
                {loader ? 'loading...' : 'Delete Request'}
              </Button>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open} className={classes.modalWidth}>
                  <Box sx={style}>
                    <Typography id="transition-modal-title" variant="h6" component="h2">
                      Account Delete Request
                    </Typography>
                    <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                      Your confirmation has been sent to your email
                    </Typography>
                  </Box>
                </Fade>
              </Modal>
            </Grid>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}

export default DeleteAccount;
